/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "fulfillment": {
                "nested": {
                  "models": {
                    "nested": {
                      "FulfillmentType": {
                        "values": {
                          "TYPE_DO_NOT_USE": 0,
                          "CUSTOM": 1,
                          "PICKUP": 2,
                          "SHIPMENT": 3,
                          "DIGITAL": 4,
                          "DELIVERY": 5,
                          "IN_STORE": 6
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.fulfillment?.nested?.models?.nested?.FulfillmentType) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc The type of fulfillment quote.
 * --
 *
 * SOURCE FulfillmentType @ squareup/fulfillment/models/fulfillment_type.proto at 19:1
 */
export const FulfillmentType = $root.lookupEnum('squareup.connect.v2.fulfillment.models.FulfillmentType').values;